import { JobBreadcrumbs } from "@/modules/work/jobs/components/header/breadcrumbs";

export const JobHeader = () => {
  return (
    <div className="sticky top-16 w-full z-30 bg-background border-b">
      <div className="h-12 px-4 flex items-center justify-start gap-4">
        <JobBreadcrumbs />
      </div>
    </div>
  );
};
